import script from "./DomainSelectionView.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainSelectionView.vue?vue&type=script&setup=true&lang=js"

import "./DomainSelectionView.vue?vue&type=style&index=0&id=67d72057&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d72057"]])

export default __exports__